var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            { staticClass: "create_team mb-1" },
            [
              _c("b-col", { attrs: { cols: "7" } }, [
                _c("h5", [_vm._v(_vm._s(_vm.$t("CONFIGURED.DOC_RETENTION")))])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("b-form-select", {
                    attrs: { plain: true, options: _vm.availableDays },
                    model: {
                      value: _vm.selectedDay,
                      callback: function($$v) {
                        _vm.selectedDay = $$v
                      },
                      expression: "selectedDay"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("vue-timepicker", {
                    staticClass: "float-right",
                    attrs: {
                      format: "HH:mm",
                      placeholder: "HH:MM",
                      "close-on-complete": ""
                    },
                    model: {
                      value: _vm.doc_retention_period,
                      callback: function($$v) {
                        _vm.doc_retention_period = $$v
                      },
                      expression: "doc_retention_period"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { align: "center" } },
            [
              _c(
                "b-btn",
                {
                  staticClass: "mt-auto",
                  attrs: { size: "md", variant: "secondary" },
                  on: { click: _vm.updateRetentionPeriod }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _vm._v(" " + _vm._s(_vm.$t("COMMON.SAVE")))
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f383252", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f383252","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/docRetention.vue
// module id = 1375
// module chunks = 2